module.exports = __webpack_public_path__ + "b3c3e4a552c1fc8c0f865380fc2ead38.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/reading/student-icons-reading.png
// module id = 3608
// module chunks = 0